import React, { useEffect } from 'react'
import rs from '../assets/images/icon/rs.png';
import c from '../assets/images/icon/c.svg'
import g from '../assets/images/icon/g.svg'
import bnb from '../assets/images/icon/BNB.png'
import { useLocation } from 'react-router-dom';

const RecurringBuy = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return (
    <>
    <h1 className="text-3xl font-semibold lg:ml-12 lg:mt-10">Recurring Buy BTC with INR</h1>
    <div className="px-6 py-10 md:flex max-w-7xl mx-auto justify-around">
      {/* Left Section */}
      <div className="">

        <h2 className="text-xl font-medium mb-6">Create Recurring Plan</h2>

        <div className="mb-4">
          <label className="block mb-1 text-sm">Select Assets</label>
          <div className="flex space-x-2">
            <div className="flex items-center border rounded px-4 py-2 w-[160px] justify-between">
              <div className="flex items-center space-x-2">
                <img
                  src={rs}
                  alt="INR"
                  className="w-5 h-5"
                />
                <span>INR</span>
              </div>
              <span>&gt;</span>
            </div>
            <div className="flex items-center border rounded px-4 py-2 w-[160px] justify-between">
              <div className="flex items-center space-x-2">
                <img
                  src={rs}
                  alt="BTC"
                  className="w-5 h-5"
                />
                <span>BTC</span>
              </div>
              <span>&gt;</span>
            </div>
          </div>
        </div>

        {/* Amount Input */}
        <div className="mb-4">
          <label className="block mb-1 text-sm">Amount</label>
          <div className="flex items-center border rounded px-4 py-2 w-[320px]">
            <input
              type="number"
              placeholder="1,500 – 100,000"
              className="flex-1 outline-none bg-transparent"
            />
            <span className="text-gray-500 ml-2">INR</span>
          </div>
        </div>

        {/* Repeat Dropdown */}
        <div className="mb-4">
          <label className="block mb-1 text-sm">Repeat</label>
          <select className="border rounded px-4 py-2 w-[320px] bg-transparent">
            <option>Weekly, Thursday, 10:00 (UTC+5)</option>
          </select>
        </div>

        {/* Receive BTC Info */}
        <div className="text-sm text-gray-500 mb-4">
          You receive <span className="text-yellow-500">0 BTC</span>.
        </div>

        {/* Continue Button */}
        <button
          disabled
          className="bg-primary py-2 px-6 rounded w-[320px] cursor-not-allowed"
        >
          Continue
        </button>
      </div>

      {/* Right Section */}
      <div className="lg:w-[30%]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Top Cryptos</h2>
          <div className="text-sm text-gray-400 space-x-3">
            <span className="text-black font-medium">3Y</span>
            <span>1Y</span>
            <span>6M</span>
            <span>3M</span>
          </div>
        </div>

        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
              <div className="flex items-center space-x-2">
              <span className="w-4 h-4 rounded-full bg-black"></span>
              <span className='text-lg'>SOL</span>
              <span className='text-xs pt-1'>HistoricalROI</span>
            </div>
            <span className="text-green-500">306.00%</span>
          </div>
          <div className="flex justify-between">
            <span className="flex items-center space-x-2">
              <span className="w-4 h-4 rounded-full bg-pink-500"></span>
              <span className='text-lg'>DOT</span>
              <span className='text-xs pt-1'>HistoricalROI</span>
            </span>
            <span className="text-red-500">-31.00%</span>
          </div>
          <div className="flex justify-between">
            <span className="flex items-center space-x-2">
              <span className="w-4 h-4 rounded-full bg-purple-500"></span>
              <span className='text-lg'>MATIC</span>
              <span className='text-xs pt-1'>HistoricalROI</span>
            </span>
            <span className="text-red-500">-57.00%</span>
          </div>
          <div className="flex justify-between">
            <span className="flex items-center space-x-2">
              <span className="w-4 h-4 rounded-full bg-orange-400"></span>
              <span className='text-lg'>LUNA</span>
              <span className='text-xs pt-1'>HistoricalROI</span>
            </span>
            <span className="text-red-500">-65.00%</span>
          </div>
          <div className="flex justify-between">
            <span className="flex items-center space-x-2">
              <span className="w-4 h-4 rounded-full bg-red-600"></span>
              <span className='text-lg'>AVAX</span>
              <span className='text-xs pt-1'>HistoricalROI</span>
            </span>
            <span className="text-green-500">18.00%</span>
          </div>
        </div>
      </div>
    </div>
    <div className="px-8 py-12">
      {/* DCA Intro */}
      <div className="mb-10">
        <h2 className="text-2xl font-semibold mb-6">
          How does dollar-cost averaging (DCA) work?
        </h2>

        <div className="mb-6">
          <h3 className="font-semibold text-lg mb-1">What is DCA?</h3>
          <p className="">
            DCA is an investment strategy where an investor invests fixed
            amounts at regular intervals to reduce the influence of volatility
            over their investment.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-1">
            How do I calculate the DCA amount for my crypto investments?
          </h3>
          <p className="">
            DCA amount = Total cost / Total no. of shares
          </p>
        </div>
      </div>

      {/* DCA Calculation Boxes */}
      <div className="flex justify-start space-x-6 mb-6">
        {/* Last Week Box */}
        <div className="border rounded-lg p-4 w-48 shadow-sm">
          <p className="text-sm mb-2">Last week</p>
          <div className="flex items-center space-x-2 font-semibold mb-1">
            <img
              src={bnb}
              alt="BNB"
              className="w-4 h-4"
            />
            <span>BNB</span>
            <span>$200</span>
          </div>
          <p className="text-sm">Amount 10</p>
          <p className="text-sm  font-medium mt-2">
            Total Cost <span className="ml-2 font-semibold">$2,000</span>
          </p>
        </div>

        {/* After Month Box */}
        <div className="border rounded-lg p-4 w-48 shadow-sm">
          <p className="text-sm mb-2">After a month</p>
          <div className="flex items-center space-x-2 font-semibold mb-1">
            <img
              src={bnb}
              alt="BNB"
              className="w-4 h-4"
            />
            <span>BNB</span>
            <span>$400</span>
          </div>
          <p className="text-sm">Amount 10</p>
          <p className="text-sm  font-medium mt-2">
            Total Cost <span className="ml-2 font-semibold">$4,000</span>
          </p>
        </div>
      </div>

      {/* Summary Calculation */}
      <div className="mb-20">
        <p className="text-sm ">
          Total Cost <span className="font-semibold ml-2">$6,000</span>
        </p>
        <p className="text-sm ">
          Total BNB Amount <span className="font-semibold ml-2">20</span>
        </p>
        <p className="text-sm  mt-1">
          Average Cost{" "}
          <span className="font-semibold ml-2">$6,000 ÷ 20 = $300/token</span>
        </p>
      </div>

      {/* Benefits of DCA */}
      <h2 className="text-2xl font-semibold mb-6">
        Benefits of DCA via Recurring Buy
      </h2>

      <div className="grid grid-cols-3 gap-6">
        {/* Benefit Card 1 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-1 w-10 h-10">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="css-4hu0bi"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.911 22.866l1.681-2.911h3.362v-3.362l2.912-1.681L21.185 12l1.68-2.911-2.911-1.682V4.046h-3.362l-1.68-2.912L12 2.815l-2.912-1.68-1.68 2.91H4.044v3.363l-2.911 1.68L2.814 12l-1.68 2.912 2.91 1.68v3.363h3.363l1.681 2.911L12 21.186l2.911 1.68z" fill="url(#certified-g_svg__paint0_linear)"></path><path d="M10.41 16.37l-3.82-3.83L8 11.13l2.41 2.41L15.95 8l1.42 1.42-6.96 6.95z" fill="#76808F"></path><defs><linearGradient id="certified-g_svg__paint0_linear" x1="12" y1="22.866" x2="12" y2="1.134" gradientUnits="userSpaceOnUse"><stop stop-color="#F0B90B"></stop><stop offset="1" stop-color="#F8D33A"></stop></linearGradient></defs></svg>
          </div>
          <h3 className="font-semibold mb-1">Steady Portfolio Growth</h3>
          <p className="text-sm ">
            Consistent investments at periodic intervals gradually grows your
            crypto wealth over time and reap the gains of invested projects’
            growth.
          </p>
        </div>

        {/* Benefit Card 2 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-1 w-10 h-10">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="css-4hu0bi"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z" fill="url(#time-clock-g_svg__paint0_linear)"></path><path d="M11 4.062c.328-.041.661-.062 1-.062h1v7.586l3.707 3.707-1.414 1.414L11 12.414V4.062z" fill="#76808F"></path><defs><linearGradient id="time-clock-g_svg__paint0_linear" x1="12" y1="22" x2="12" y2="2" gradientUnits="userSpaceOnUse"><stop stop-color="#F0B90B"></stop><stop offset="1" stop-color="#F8D33A"></stop></linearGradient></defs></svg>
          </div>
          <h3 className="font-semibold mb-1">Disciplined Saving</h3>
          <p className="text-sm ">
            Automates your crypto purchases and ensures you invest with
            discipline regardless of market conditions.
          </p>
        </div>

        {/* Benefit Card 3 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-3">
            <img
              src={g}
              alt="Risk"
              className="w-8 h-8"
            />
          </div>
          <h3 className="font-semibold mb-1">Risk Reduction</h3>
          <p className="text-sm ">
            Manages impact from the volatile crypto market by spreading out your
            investments and smoothing out price swings.
          </p>
        </div>

        {/* Benefit Card 4 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-3">
            <img
              src={c}
              alt="Convenience"
              className="w-8 h-8"
            />
          </div>
          <h3 className="font-semibold mb-1">Convenience & Flexibility</h3>
          <p className="text-sm ">
            Choose between weekly, bi-weekly or even monthly purchases and
            cryptocurrencies you want to buy beforehand.
          </p>
        </div>

        {/* Benefit Card 5 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-3">
            <img
              src={g}
              alt="Ecosystem"
              className="w-8 h-8"
            />
          </div>
          <h3 className="font-semibold mb-1">
            Easy Access to the Tillionx Ecosystem
          </h3>
          <p className="text-sm ">
            Get your stash of crypto ready to explore other Tillionx products
            such as staking, spot trading, or even buying your first NFT.
          </p>
        </div>

        {/* Benefit Card 6 */}
        <div className="border p-6 rounded-lg">
          <div className="mb-1 w-10 h-10">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="css-4hu0bi"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 21l8.543-8.525a4.957 4.957 0 000-7.021 4.982 4.982 0 00-7.035 0L12 6.958l-1.508-1.504a4.982 4.982 0 00-7.035 0 4.957 4.957 0 000 7.02L12 21zm-1.5-8L9 14.5l1.5 1.5 1.5-1.5-1.5-1.5z" fill="url(#heart-g_svg__paint0_linear)"></path><path d="M11 2.5L12.5 1 14 2.5 12.5 4 11 2.5zM2 13l2-2 2 2-2 2-2-2zM19 18l-2 2 2 2 2-2-2-2z" fill="#76808F"></path><defs><linearGradient id="heart-g_svg__paint0_linear" x1="12" y1="21" x2="12" y2="4" gradientUnits="userSpaceOnUse"><stop stop-color="#F0B90B"></stop><stop offset="1" stop-color="#F8D33A"></stop></linearGradient></defs></svg>
          </div>
          <h3 className="font-semibold mb-1">Emotional Detachment</h3>
          <p className="text-sm ">
            Remove the stress of timing the market and making impulsive
            decisions based on market conditions.
          </p>
        </div>
      </div>
        <div>
            <h4 className='my-8 text-3xl w-full'>Risks of DCA via Recurring Buy</h4>

            <h6 className='text-xl w-full'>Missing Out on Large Gains</h6>
            <p>DCA does not include lump sum investments during market dips, thus you may miss out on a larger profit.</p>

            <h6 className='mt-6 marker:text-xl w-full'>Crypto Facts</h6>
            <p>Such large gains require investors to time the market correctly which is almost impossible, which is why DCA can help smooth out market timings.</p>

            <h6 className='mt-6 text-xl w-full'>Lack of Detailed Investment Information</h6>
            <p>DCA strategy does not help identify good investments. Hence, it’s important to DYOR before committing to a DCA approach.</p>
        </div>

        
    </div>
    </>
  )
}

export default RecurringBuy